<template>
    <div class="rhheader">
        <img src="@/assets/imgs/top_logo.png">
        <div class="rhheader-right">
            <img :src="userInfo && userInfo.avatar ? userInfo.avatar : require(`@/assets/imgs/default_face.png`)">
            <el-dropdown>
                <span class="el-dropdown-link">
                    {{userInfo && userInfo.contact}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="onSeeInfo"><i class="el-icon-user headeri" ></i>个人信息</el-dropdown-item>
                    <el-dropdown-item @click.native="onAlertPwd"><i class="el-icon-lock headeri"></i>修改密码</el-dropdown-item>
                    <el-dropdown-item @click.native="onLogout"><i class="el-icon-switch-button headeri"></i>退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <alert-pwd :visible.sync="dialogVisible" ></alert-pwd>
    </div>
</template>
<script>
import "./comps.less";
import {mapState} from 'vuex';
import alertPwd from '../../userInfo/alertPwd.vue';

import pollingTask from './pollingTask.js'
let exportCustomerTimer = null
export default {
    components: { alertPwd },
    name: "rhHeader",
    data() {
        return {
            dialogVisible:false
        };
    },
    computed: {
        ...mapState({
            userInfo: function(state){
                return state.app.userInfo
            },
        })
    },
    mounted() {
        let that = this
        this.$bus.on("exportCustomer",function(){
            pollingTask.onExportCustomer()
        })
        this.$bus.on("exportAccount",function(){
            pollingTask.onExportAccount()
        })
    },
    destroyed() {
        this.$bus.$off("exportAexportCustomerccount")
        this.$bus.$off("exportAccount")
    },
    methods: {
        onSeeInfo(){
            this.$router.push('/userInfo')
        },
        onAlertPwd(){
            this.dialogVisible = true
        },
        onLogout(){
            this.$store.commit('UPDATE_ISPASS',true)
            this.$store.dispatch('delAllViews')
            let savepwd = $storage.getItem('savePwd',1)
            let userphone = $storage.getItem('userphone',1)
            localStorage.clear();
            sessionStorage.clear();
            $storage.setItem("savePwd",savepwd,1)
            $storage.setItem("userphone",userphone,1)
            this.$router.push({path:'/login'})
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/pages/layout/comps/rhHeader.vue